export enum Roles {
  administrator = 1,
  head = 2,
  engineerPTO = 3,
  constructionControlEngineer = 4,
  contractorOrganization = 5,
  foreman = 6,
}
